import { Outlet } from 'react-router'
import { VibeKanbanWebCompanion } from 'vibe-kanban-web-companion'

import { Toaster } from '@/components/ui/sonner'
import { isProduction, isStaging } from '@/config/config'

/** The root of every page, whichever product it belongs to. */
export function Root() {
  return (
    <>
      <link
        rel="icon"
        type="image/svg+xml"
        href={isProduction ? '/favicon.svg' : isStaging ? '/favicon-staging.svg' : '/favicon-dev.svg'}
      />
      <Outlet />
      <VibeKanbanWebCompanion />
      <Toaster position="top-center" />
    </>
  )
}
